if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.sectionIdPrefix = 'quickadd-';
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      if (!opener || !this.modalContent) {
        console.error('Quick Add modal: Missing required elements');
        return;
      }

      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const productUrl = opener.getAttribute('data-product-url');
      if (!productUrl) {
        console.error('Quick Add modal: Missing product URL');
        this.showError(opener, 'Missing product URL');
        return;
      }

      fetch(productUrl)
        .then((response) => {
          if (response.status === 404) {
            throw new Error('product_not_found');
          }
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          if (this.isProductUnavailable(responseText)) {
            throw new Error('product_not_found');
          }

          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          if (!this.productElement) {
            throw new Error('Product section not found in response');
          }

          this.handleProductAvailability(opener);
        })
        .catch((error) => {
          console.error('Quick Add modal error:', error);
          this.showError(opener, error.message === 'product_not_found' 
            ? 'This product is no longer available' 
            : 'Unable to load product details');
        })
        .finally(() => {
          this.resetOpenerState(opener);
        });
    }

    isProductUnavailable(responseText) {
      return responseText.includes('class="product-404"') || 
             responseText.includes('class="product--no-js"') || 
             responseText.toLowerCase().includes('product does not exist');
    }

    handleProductAvailability(opener) {
      const addToCartBtn = this.productElement.querySelector('[type="submit"][name="add"]');
      const preorderBtn = this.productElement.querySelector('[type="submit"][name="add"][value="Pre-order"]');
      const isSoldOut = (!addToCartBtn || addToCartBtn.hasAttribute('disabled') || 
                        addToCartBtn.textContent.toLowerCase().includes('sold out')) &&
                        !preorderBtn;

      if (isSoldOut) {
        this.showError(opener, 'This product is currently out of stock');
        return;
      }

      this.renderProductContent();
      this.initializeScripts();
      super.show(opener);
    }

    renderProductContent() {
      this.preventDuplicatedIDs();        
      this.removeDOMElements();
      this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
      this.removeGalleryListSemantic();
      this.setupVariantSelector();
    }

    initializeScripts() {
      if (window.Shopify?.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.ProductModel) {
        window.ProductModel.loadShopifyXR();
      }
    }

    showError(opener, message) {
      this.modalContent.innerHTML = `
        <div class="quick-add-error">
          <p><strong>Error:</strong> ${message}</p>
          <button type="button" class="button" onclick="this.closest('quick-add-modal').hide()">Close</button>
        </div>
      `;
      super.show(opener);
    }

    resetOpenerState(opener) {
      if (opener) {
        opener.removeAttribute('aria-disabled');
        opener.classList.remove('loading');
        const spinner = opener.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    setInnerHTML(element, html) {
      const container = document.createElement('div');
      container.innerHTML = html;

      container.querySelectorAll('script').forEach((script) => {
        const newScript = document.createElement('script');
        Array.from(script.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        script.replaceWith(newScript);
      });

      element.innerHTML = '';
      while (container.firstChild) {
        element.appendChild(container.firstChild);
      }
    }

    setupVariantSelector() {
      const variantSelector = this.modalContent.querySelector('variant-radios, variant-selects');
      if (variantSelector) {
        variantSelector.setAttribute('data-update-url', 'false');
        // Fixed selector - changed from :radio to [type="radio"]
        const colorRadios = this.modalContent.querySelectorAll('input[type="radio"][name="Color"]');
        if (colorRadios.length) {
          colorRadios.forEach(radio => {
            radio.addEventListener('change', (e) => {
              const swatch = e.target.nextElementSibling;
              if (swatch?.classList?.contains('swatch-element')) {
                document.querySelectorAll('.swatch-element.clicked').forEach(el => {
                  el.classList.remove('clicked');
                });
                swatch.classList.add('clicked');
              }
            });
          });
        }
      }
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;
      const idRegex = new RegExp(sectionId, 'g');
      this.productElement.innerHTML = this.productElement.innerHTML.replace(idRegex, `${this.sectionIdPrefix}${sectionId}`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeDOMElements() {
      const selectorsToRemove = [
        'pickup-availability',
        'product-modal',
        '[id^="dT_bundleSelector"]',
        '.product__info-as-bottom-tabs'
      ];

      selectorsToRemove.forEach(selector => {
        const elements = this.productElement.querySelectorAll(selector);
        elements.forEach(el => el.remove());
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => {
        li.setAttribute('role', 'presentation');
      });
    }
  });
}